import i18n from 'shared/lib/i18n';

import ViewExportContainer from '../ViewExport/ViewExportContainer';

import { formatDate } from '../../utils';

const getTableData = (data, columns) => {
  const headers = columns
    .filter(({ id }) => id !== 'actions')
    .map(({ Header }) => Header);

  const rows = [];

  data.forEach(
    ({
      name,
      address: { address1, city, state },
      unitsCount,
      parent,
      type,
      launchDate,
      softwareOnly,
      frozen,
    }) => {
      rows.push([
        name,
        address1,
        city,
        state,
        String(unitsCount),
        parent?.name,
        type,
        formatDate(launchDate, true, 'MM/DD/YYYY'),
        softwareOnly ? i18n.t('common.yes') : i18n.t('common.no'),
        frozen ? i18n.t('common.yes') : i18n.t('common.no'),
      ]);
    },
  );
  return { headers, rows };
};

const BuildingTableExport = (props) => (
  <ViewExportContainer {...props} getTableData={getTableData} />
);

export default BuildingTableExport;
